
export default {
  btnLoading: false,
  username: '',
  user: {},
  indexNav: [
    {
      title: '主页',
      index: '/index'
    }
  ],
  order: {}
}



// WEBPACK FOOTER //
// ./src/vuex/state.js